import { AxiosResponse } from 'axios';
import { api } from '../../../lib';

export type UploadPriceTableResponse = {
  message: string;
  totalProcessed: number;
};

export type PriceTableLastUpdateResponse = {
  lastUpdate?: string | null;
};

const UPLOAD_ENDPOINT = '/price-list/upload';
const TEMPLATE_ENDPOINT = '/price-list/upload/template';
const LAST_UPDATE_ENDPOINT = '/price-list/upload/last-update';

export const PRICE_TABLE_LAST_UPDATE_QUERY_KEY = ['price-table-last-update'] as const;

export const getPriceTableLastUpdate = async (): Promise<PriceTableLastUpdateResponse> => {
  const response = await api({
    url: LAST_UPDATE_ENDPOINT,
    method: 'GET',
    expectToken: true,
  });

  return response.data;
};

export const uploadPriceTable = (file: File): Promise<AxiosResponse<UploadPriceTableResponse>> => {
  const formData = new FormData();
  formData.append('file', file);

  return api({
    url: UPLOAD_ENDPOINT,
    method: 'POST',
    expectToken: true,
    data: formData,
  });
};

const getDownloadFileName = (contentDisposition?: string) => {
  const encodedFileName = contentDisposition?.match(/filename\*=UTF-8''([^;]+)/i)?.[1];
  const regularFileName = contentDisposition?.match(/filename="?([^";]+)"?/i)?.[1];

  if (encodedFileName) {
    return decodeURIComponent(encodedFileName);
  }

  return regularFileName || 'modelo_tabela_de_precos.xlsx';
};

export const downloadPriceTableTemplate = async () => {
  const response = await api({
    url: TEMPLATE_ENDPOINT,
    method: 'GET',
    expectToken: true,
    responseType: 'arraybuffer',
  });

  const objectUrl = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');

  link.href = objectUrl;
  link.download = getDownloadFileName(response.headers?.['content-disposition']);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(objectUrl);
};
